<script>

export default {
    name: 'TechDetail',
    props:[
        "data"
    ],
    data() {
        return {
            submitted: false,
            form:{},
        };
    }, 
    computed:{
        modalTitle(){ return this.form.type == 4 ? "Taşıma Detayı" : "Arıza Detayı" },
    },
    watch:{
        data:{
            handler(newv){
                this.form= newv
                
                if(newv.subject){
                    this.form = { ...this.form,tc_name:newv.subject}
                }
            },
            deep:true
        },
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('tech_detail')
        }
    },
};
</script>

<template>
<b-modal id="tech_detail"  :title="modalTitle"  no-close-on-backdrop hide-footer>
    <form class="needs-validation">
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label">İsim Soyisim</label>
            <div class="col col-form-label">{{ form.fullname }}</div>
        </div>
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label">Telefon</label>
            <div class="col col-form-label">{{ form.phonenumber }}</div>
        </div>
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label">Whatsapp</label>
            <div class="col col-form-label">{{ form.phonenumber }}</div>
        </div>
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label">Adres</label>
            <div class="col col-form-label">{{ form.address }}</div>
        </div>
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label">İlçe</label>
            <div class="col col-form-label">{{ form.province }}</div>
        </div>
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label">Bölge</label>
            <div class="col col-form-label">{{ form.quarter_name || form.township }}</div>
        </div>
        <div class="row d-flex flex-wrap" v-if="form.type != 4"> 
            <label class="col-sm-4 col-form-label">Arıza Türü</label>
            <div class="col col-form-label">{{ form.tc_name }}</div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.type != 4"> 
            <label class="col-sm-4 col-form-label">Arıza Açıklaması</label>
            <div class="col col-form-label">{{ form.content }}</div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.type == 4"> 
            <label class="col-sm-4 col-form-label">Yeni Adres</label>
            <div class="col col-form-label">{{ form.newaddress }} {{ form.newtownship }} / {{ form.newprovince }} </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <button class="btn btn-light" style="width:100%" type="button" @click="close()">Kapat</button>
        </div>
    </form>
</b-modal>
</template>